module.exports = __webpack_public_path__ + "img/pointicon@2x_1.3f3552d1.svg";